export default "__VITE_ASSET__Ccdu_wVR__"